module.exports = __webpack_public_path__ + "img/CM-MS-24-Toyota-Lifestyle.1cc5a689.jpg";